import { Action } from 'redux';

import { ChangeExtractRefreshSchedule } from '../../../bootstrap/redux/actions/AppActionTypes';
import { IExtractTaskInfo } from '../../../extractTask/models/IExtractTaskInfo';

export interface ChangeExtractRefreshScheduleAction extends Action {
  tasks: IExtractTaskInfo[];
}

export function changeExtractRefreshSchedule(tasks: IExtractTaskInfo[]): ChangeExtractRefreshScheduleAction {
  return {
    type: ChangeExtractRefreshSchedule,
    tasks
  };
}
